module.exports = "/img/_/_/_/assets/images/creeper/book/common//17.jpg?65095e2760ca9377a704ded6a6e7ade8";